import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { onSaveImageData } from "../../../store/actions/nct";
import { RootStateType } from "../../../store/reducers";
import { ImageSaveType } from "../../../store/types/nct";
import { OTP_ACTIONS } from "../../../utils/constants";
import UploadDocumentScreen from "../UploadDocumentScreen";
import { updateEmail } from "../../../store/actions/nct";
import { fetchInvestorDetails } from "../../../store/actions/nct";
import { getMatchAndUnMatchedFunds } from "../../../utils/utilityFunctions";
import {
  getPortfoliosFilteredData,
  portfoliosByMinorStatus,
  portfoliosByModeOfHolding,
  portfoliosByTransactionResource,
} from "../../home/portfolios/utils";
import { getErrorMessage, getInvestorFunds } from "../portfolios/utils";
import en from "../../../lang/en-us";
import { RowInfoType } from "./change-email-list";
//import InfoIcon from "@mui/icons-material/Info";
import React from "react";
import { BackArrow } from "../UpdateNominee/SelectedFolios";
const { dashboard } = en;

function ChangeEmailDocument(props: any) {
  const [rowData, setRowData] = useState<RowInfoType[]>([]);
  const { enteredEmail: email, emailRelationship } = props.location.state || {};
  const [Document, setDocument] = useState<any>({
    image: { name: "EMAIL_CHANGE", format: "", content: "" },
  });

  const handleImageSelection = (value: any, format: any) => {
    setDocument({
      image: {
        ...Document.image,
        format: format,
        content: value,
      },
    });
  };
  useEffect(() => {
    if (!props?.location?.state?.isPhygitial) return;
    async function fetchPortfolio() {
      try {
        // setLoading(true);
        const { pan = "", pekrn = "", mobile = "", reqId = "" } = props;

        // await props.getPortfolio({
        //   pan,
        //   pekrn,
        //   mobile,
        //   reqId,
        // });
        const payload = {
          pan: props.investorData.PAN,
          brokercode: props.token,
        };
        const { body: investorDetails = {} } = await props.fetchInvestorDetails(
          payload
        );
        const { success: nomineeFunds = [] } = investorDetails;
        const filters = [
          portfoliosByModeOfHolding,
          portfoliosByMinorStatus,
          portfoliosByTransactionResource,
        ];
        const funds = getMatchAndUnMatchedFunds(
          filters,
          getInvestorFunds(nomineeFunds),
          true
        ).map((fund) => {
          return { ...fund, error: getErrorMessage(fund, filters) };
        });
        const { nomineeFunds: _nomineeFunds = [], otherFunds = [] } =
          funds.reduce((prev: any, fund: RowInfoType) => {
            if (fund?.nominees?.length) {
              return {
                ...prev,
                nomineeFunds: [...(prev.nomineeFunds ?? []), fund],
              };
            }
            return { ...prev, otherFunds: [...(prev.otherFunds ?? []), fund] };
          }, []);
        const rows: RowInfoType[] = [...otherFunds, ..._nomineeFunds].map(
          (item) => ({
            folio:item.folio,
            amc: item.amc,
            amcName: item.amcName,
            email: item.email,
            id: item.id,
            investorName: item.investorName,
            mobile: item.mobile || "N/A",
            assetType: item.assetType,
          })
        );
        // .filter((item) => item.email != email);

        // setRowData([...otherFunds, ..._nomineeFunds]);
        // setSelectedRows([...otherFunds, ..._nomineeFunds]);

        setRowData(rows);

        // setLoading(false);
      } catch (err: any) {
        alert(err.message);
        // setLoading(false);
      }
    }
    fetchPortfolio();
  }, []);
  const handleSubmission = async () => {
    if (props?.location?.state?.isPhygitial) {
      try {
        const investorName = props.investorData.invname;
        const investorPan = props.investorData.PAN;
        const investor = props.investors.find(
          (item: any) =>
            item.Name.toLowerCase() === investorName.toLowerCase() ||
            item.Pan.toLowerCase() == investorPan.toLowerCase()
        );

        const newData = rowData.map((item) => ({
          folio: item.folio,
          amc: item.amc,
          amc_name: item.amcName,
        }));

        const payload: {
          email: string;
          newEmail: string;
          mobile: string;
          image: any | null;
          relation: string;
          pan: string;
          distributor_id: string;
          data: any;
        } = {
          email: investor.Email,
          newEmail: email,
          mobile: investor.Mobile,
          image: Document.image,
          relation: emailRelationship,
          pan: investorPan,
          distributor_id: props.token,
          data: newData,
        };
        
        const res = await props.updateEmail(payload);

        alert(res.message);
        props.history.push("/new-transaction/nct-types");
      } catch (err: any) {
        alert(err.message);
      }
    } else {
      try {
        const payload = {
          ...props.location.state.payload,
          image: Document.image,
        };
       
        const res = await props.updateEmail(payload);

        alert(res.message);

        props.history.push("/new-transaction/nct-types");
      } catch (err: any) {
        alert(err.message);
      }
    }

    // props.history.replace("change-email", {
    //   images: [Document.image],
    //   action: OTP_ACTIONS.NEW_EMAIL_OFFLINE_OTP,
    //   ...(props?.location?.state || {}),
    // });
  };

  // save image in store
  useEffect(() => {
    return () => {
      const imageInfo: ImageSaveType = {
        data: [Document.image],
        type: "CHANGE_EMAIL",
      };
      props.onSaveImageData(imageInfo);
    };
  }, [Document]);

  return (
    <>
      <div className="curved-bg">
      <BackArrow history={props.history}/>
        <UploadDocumentScreen
          email={
            props?.location?.state?.isPhygitial
              ? email
              : props?.location?.state?.payload?.newEmail
          }
          emailInfo="The new Email ID will be updated across all folios."
          backLink="nct/change-email"
          heading={dashboard.changeEmail.changeEmailHeading}
          subheading={dashboard.changeEmail.UploadDocument.subHeading}
          info1={dashboard.changeEmail.UploadDocument.subHeadingInfo1}
          linkText={dashboard.changeEmail.UploadDocument.subHeadingInfo2}
          info2={dashboard.changeEmail.UploadDocument.subHeadingInfo3}
          nextLink="change-email"
          id="upload-scanned-document"
          onImageSelected={handleImageSelection}
          handleSubmit={handleSubmission}
          isDisabled={!!Document.image.content}
          hrefLink={
            process.env.REACT_APP_S3_CLOUD_URL + "/Updation_of_Email_Id.docx"
          }
        />
      </div>
    </>
  );
}
export default connect(
  ({ authReducer, portfolio, investor }: RootStateType) => ({
    ...authReducer,
    ...portfolio,
    ...investor,
  }),
  { onSaveImageData, updateEmail, fetchInvestorDetails }
)(ChangeEmailDocument);

// export default {};
